import { useGlobalStore } from '@frontend/libs/stores/globalStore'
import { Modal, ModalContent } from '@nextui-org/react'

import SignInForm from './SignInForm'

export function SignInPopup() {
  const { isLoginPopupOpen, onLoginPopupOpenChange } = useGlobalStore(
    (state) => state,
  )

  return (
    <Modal
      className="px-14 py-16"
      classNames={{
        closeButton: 'rounded-none top-4 right-4 text-2xl z-20',
      }}
      isOpen={isLoginPopupOpen}
      onOpenChange={onLoginPopupOpenChange}
      placement="center"
      size="2xl"
    >
      <ModalContent>
        <SignInForm />
      </ModalContent>
    </Modal>
  )
}

export default SignInPopup
